import { MapResponseToDropdown } from "../Models/Models";

export const mapResponseToDropdown = <T extends Record<string, any>>(
  data: T[],
  labelKey: keyof T,
  valueKey: keyof T,
  extraField1Key?: keyof T,
  extraField2Key?: keyof T,
  extraField3Key?: keyof T
): MapResponseToDropdown[] => {
  return data?.map((item) => ({
  label: String(item[labelKey]),
    value: String(item[valueKey]),
    extraField1: extraField1Key ? String(item[extraField1Key]) : undefined,
    extraField2: extraField2Key ? String(item[extraField2Key]) : undefined,
    extraField3: extraField3Key ? Number(item[extraField3Key]) : undefined,
  }));
};

export async function sha256(message: string): Promise<string> {
  // Encode the message as a UTF-8 byte array
  const msgBuffer = new TextEncoder().encode(message);

  // Hash the message using SHA-256
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

  // Convert the hash buffer to an array of bytes
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // Convert the bytes to a hexadecimal string
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

  return hashHex;
}


    export  const UrlConfigs = {
      MAP_STYLE_URL: "mapbox://styles/mapbox/streets-v11",
      MAPBOX_ACCESS_TOKEN:
        "pk.eyJ1Ijoic3JpbmF0aHJhamEiLCJhIjoiY2xoNXR2NGp2MGJzMDNlczg5ZDA5ZTNwdSJ9.VPL2vn4eXArjXHpPz9RYQg",
      API_URL: "https://api.pixvisonz.com/v1/",
    };

   